import { useTranslation } from 'react-i18next'
import type { PipelineKind } from '@ludus/core'

type Words = (key: string, opts: { defaultValue: string; [k: string]: unknown }) => string

/**
 * `t` for a board of a given kind: a board of interactions answers from the
 * `key_interaction` variant when the dictionary has one, and from the base key
 * otherwise (#66). The kind is the neutral axis — no source's own word reaches
 * the console (ADR-0004 §1).
 */
export function useWords(kind: PipelineKind): Words {
  const { t } = useTranslation()
  const context = kind === 'interaction' ? { context: 'interaction' } : {}
  return (key, opts) => t(key, { ...opts, ...context })
}
